import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { ReplaySubject, takeUntil } from 'rxjs';

import { ClosedCaptionItem, ClosedCaptionsService } from './../services/closed-captions/closed-captions.service';

@Component({
  selector: 'app-closed-captions',
  templateUrl: './closed-captions.component.html',
  styleUrls: ['./closed-captions.component.scss'],
  standalone: false,
})
export class ClosedCaptionsComponent implements OnInit, OnDestroy {
  @Input() public presentationMode?: boolean;

  private destroyed$ = new ReplaySubject<boolean>(1);
  public captionList: ClosedCaptionItem[] = [];

  public constructor(private closedCaptionsService: ClosedCaptionsService) {}

  public ngOnInit(): void {
    this.closedCaptionsService.closedCaptionsStream$.pipe(takeUntil(this.destroyed$)).subscribe((captions) => {
      if (captions) {
        this.captionList = captions;
      }
    });
  }

  public formatName(firstName?: string, lastName?: string): string {
    return lastName ? `${firstName} ${lastName}` : `${firstName}`;
  }

  public ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
